// Unpublished Work © 2021-2022 Deere & Company

import {
    RESET_SELECT_BUSINESS_CONTACT,
    SET_SELECT_BUSINESS_CONTACT_DATA
} from '../../action-list';
import {Customer} from '../../state/struct/customer';

const setSelectedBusinessContactData = (state, action) => new Customer(action.selectBusinessContact.customer);

const resetCustomerProfile = () => new Customer({});

export function customer(state = new Customer({}), action = {}) {
    const actionHandlers = {
        [RESET_SELECT_BUSINESS_CONTACT]: resetCustomerProfile,
        [SET_SELECT_BUSINESS_CONTACT_DATA]: setSelectedBusinessContactData
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
